import { Alert, Snackbar } from "@mui/material";
import FilterVehicle from "components/Request/FilterVehicle";
import Request from "components/Request/Request";
import React, { Component } from "react";
import { RequestVehicleApi } from "stores/Request/RequestApi";

function debounce(func, delay) {
  let timer;
  return function(...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}


export default class RequestContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "1",
      filterdrawerOpen:false,
      vehicledrawerOpen: false,
      response: "vehicle",
      responseManufacturer:'',
      datePickerOpen: false,
      rejectRequestOpen:false,
      inputSearch:'',
      formData:{
        manufacturer:'',
        model:'',
        variant:'',
        from_date: "",
        to_date: "",
      },
      modalMessage:{
        open:false,
        message:''
      },
      filterData:{
        manufacturer: [],
        manufacturer_type: [],
        sub_type: [],
        variant_name: [],
        model_name: [],
        ac_names: [],
        dc_names: [],
      },
      page: 0,
      limit: 100,
      manufacturerInputFieldOpen:false,
      modelInputFieldOpen:false,
      variantInputFieldOpen:false,
      searchkeyword:''
     
     
    };

    this.debouncedSearch = debounce(this.performSearch.bind(this), 500);

  }

  handleManufacturerInputFieldOpen = ()=>{
    this.setState({manufacturerInputFieldOpen:true})
  }
  handleModelInputFieldOpen = ()=>{
    this.setState({modelInputFieldOpen:true})
  }
  handleVariantInputFieldOpen = ()=>{
    this.setState({variantInputFieldOpen:true})
  }

  performSearch(searchQuery) {
    this.setState({searchkeyword:searchQuery})
    if (searchQuery) {
      this.props.getRequestVehicleDataAction({search_term:searchQuery});
      return;
    }
    else this.props.getRequestVehicleDataAction({limit:this.state.limit});
  }

  componentDidMount() {
    this.props.getRequestVehicleDataAction({ limit: this.state.limit,
      page: this.state.page
    }
    );
  }
  handleDatePickerOpen = () => {
    this.setState({ datePickerOpen: true });
  };

  onDatePickerSub = async () => {
    this.handleFilterApiData();
  };
  handleDatePickerClose = () => {
    this.setState({ datePickerOpen: false });
  };
  handleChange = (name, value) => {
    const { formData } = this.state;
    if (name === "from_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_from"] = this.formatDateMonth(new Date(value));
    } else if (name === "to_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_to"] = this.formatDateMonth(new Date(value));
    } else {
      formData[name] = value;
    }

    // this.handleFilterApiData();
    this.setState({ formData });
  };
  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  formatDateMonth(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (day.length < 2) day = "0" + day;

    month = month - 1;

    return [day, monthNames[month], year].join(" ");
  }
  handleFilterApiData = async () => {
    await this.props.getRequestVehicleDataAction({
      limit:this.state.limit,
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
      search_term:this.state.searchkeyword

    });
  };
  handleReset = async () =>{
    await this.props.getRequestVehicleDataAction({
      limit: this.state.limit,
      page: this.state.page,
      search_term:this.state.searchkeyword
    });
    this.setState({ formData: {
      from_date: "",
      to_date: "",
    }})
  }
  handleFilterRequestVehicle = (data) => {
    if (data && data.manufacturer && data.manufacturer_type) {
      const formattedVehicles = {
        manufacturer: data?.manufacturer?.map((item) => item.name),
        manufacturer_type: data?.manufacturer_type?.map((item) => item.name),
        variant_name: data?.variant_name?.map((item) => item.name),
        model_name: data?.model_name?.map((item) => item.name),
        usage: data?.usages?.map((item) => item.name),
        i_am: data?.i_am?.map((item) => item.name),
        from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
      search_term:this.state.searchkeyword
      };
      this.props.getRequestVehicleDataAction(formattedVehicles);

      this.setState({
        filterData: {
          manufacturer: data.manufacturer.map((item) => item.name),
          manufacturer_type: data.manufacturer_type.map((item) => item.name),
          sub_type: data.sub_type?.map((item) => item.name) || [],
          variant_name: data.variant_name?.map((item) => item.name) || [],
          model_name: data.model_name?.map((item) => item.name) || [],
          ac_names: data.ac_names?.map((item) => item.name) || [],
          dc_names: data.dc_names?.map((item) => item.name) || [],
        }
      });
    } else {
      console.error("Invalid data format:", data);
    }
  };
  handleSnackbarClose=()=>{
    this.setState({
      modalMessage: {
        open: false,
      }
    });
  }

  onPageChange = (page, rowsPerPage) => {
  
    this.setState({
      page: page,
      limit: rowsPerPage,
    });
    const payload = {
      limit: rowsPerPage,
      page: page,
      search_term:this.state.searchkeyword,
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
      manufacturer: this.state.filterData.manufacturer,
      manufacturer_type: this.state.filterData.manufacturer_type,
      sub_type: this.state.filterData.sub_type,
      variant_name:this.state.filterData.variant_name,
      model_name: this.state.filterData.model_name,
      ac_names: this.state.filterData.ac_names,
      dc_names: this.state.filterData.dc_names,
    };
    this.props.getRequestVehicleDataAction(payload);
    
  };

  searchhandleChange = ( value) => {
    const query = value;
    this.setState({inputSearch: query });
    this.debouncedSearch(query);
  };



  handleFiltertoggleDrawerOpen = () => {
    this.setState({ filterdrawerOpen: true });
  };
  handleFiltertoggleDrawerClose = () => {
    this.setState({ filterdrawerOpen: false });
  };
  vehicletoggleDrawerRequest = ({manufacturer}) => {
    if(manufacturer?.id){
      this.setState({ vehicledrawerOpen: true });
    }else{
      this.setState({ vehicledrawerOpen: false });

    }
    this.setState({responseManufacturer:manufacturer})
  };
  handleCloseModal=()=>{
    this.setState({ vehicledrawerOpen: false });
    this.setState({manufacturerInputFieldOpen:false})
    this.setState({modelInputFieldOpen:false})
    this.setState({variantInputFieldOpen:false})
  }
  handleRejectModalOpen=()=>{
    this.setState({rejectRequestOpen:true})
  }
  handleRejectModalClose=()=>{
    this.setState({rejectRequestOpen:false})

  }
  handleOnChange = (name, value) => {
    this.setState(prevState => ({
        formData: {
            ...prevState.formData,
            [name]: value
        }
    }));
}


 handleRejectRequestVehicle= async()=>{
  try {
    const res = await RequestVehicleApi.rejectRequestApi(this.state.responseManufacturer?.id)
    if(res.status=== 1){
      this.handleRejectModalClose()
      this.handleCloseModal()
      this.setState({
        modalMessage: {
          open: true,
          message: res?.message
        }
      });
    }
    const payload = {
      limit: this.state.limit,
      page: this.state.page,
      search_term:this.state.searchkeyword,
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
      manufacturer: this.state.filterData.manufacturer,
      manufacturer_type: this.state.filterData.manufacturer_type,
      sub_type: this.state.filterData.sub_type,
      variant_name:this.state.filterData.variant_name,
      model_name: this.state.filterData.model_name,
      ac_names: this.state.filterData.ac_names,
      dc_names: this.state.filterData.dc_names,
    };
    this.props.getRequestVehicleDataAction(payload);
   
  } catch (error) {
    console.error('Error submitting reply:', error);
  }
 }

 handleApproveRequestVehicle= async()=>{
  try {
    const res = await  RequestVehicleApi.approveRequestApi(this.state.responseManufacturer?.id)
    if(res.status=== 1){
      this.handleCloseModal()
      this.setState({
        modalMessage: {
          open: true,
          message: res?.message
        }
      });
      const payload = {
        limit: this.state.limit,
        page: this.state.page,
        search_term:this.state.inputSearch,
        from_date: this.state.formData.from_date,
        to_date: this.state.formData.to_date,
        manufacturer: this.state.filterData.manufacturer,
        manufacturer_type: this.state.filterData.manufacturer_type,
        sub_type: this.state.filterData.sub_type,
        variant_name:this.state.filterData.variant_name,
        model_name: this.state.filterData.model_name,
        ac_names: this.state.filterData.ac_names,
        dc_names: this.state.filterData.dc_names,
      };
      this.props.getRequestVehicleDataAction(payload);
    }
   
  } catch (error) {
    console.error('Error submitting reply:', error);
  }
 }


 handleUpdateRequestVehicle = async(model_id,varient_id)=>{
  try {
    const res = await  RequestVehicleApi.approveUpdateRequestApi({id:this.state.responseManufacturer?.id, model:model_id, variant:varient_id})
    if(res.status=== 1){
      this.handleCloseModal()
      // this.setState({manufacturerInputFieldOpen:false})
      // this.setState({modelInputFieldOpen:false})
      // this.setState({variantInputFieldOpen:false})
      this.setState({ formData:{
        manufacturer:'',
        model:'',
        variant:'',
      }})
      this.setState({
        modalMessage: {
          open: true,
          message: res?.message
        }
      });
      this.props.getRequestVehicleDataAction();
    }
   
  } catch (error) {
    console.error('Error submitting reply:', error);
  }
 }

  handleTabChange = (e, newValue) => {
    this.setState({ value: newValue });
    // const chek = this.state.value
    if (newValue === "1") {
      this.setState({ response: "vehicle" });
    } else {
      this.setState({ response: "connector" });
    }
  };

  dropdownFilterData = this.props.RequestVehicleDataList?.dropdowns

  render() {
    const filtermanufacture = this.dropdownFilterData?.manufacturers.map(item => item.name) || [];
    const filtermanufactureType = this.dropdownFilterData?.manufacturer_types.map(item => item.name) || [];
    const filtervariants = this.dropdownFilterData?.variants.map(item => item.name) || [];
    const filtermodels = this.dropdownFilterData?.models.map(item => item.name) || [];

    return (
      <div>
        <Request
          getVarientDropdown = {this?.props?.getVehicleVariantData}
          getVarientDropdownData = {this.props.getVariantdropdowndata?.result?.data ?? []}
          modelDropdownData={this?.props?.getModeldropdowndata?.result ?? []}
          getModalDropdown={this.props.getVehicleModelData}
          handleTabChange={this.handleTabChange}
          value={this.state.value}
          response={ this.state.response}
          vehicletoggleDrawerRequest={this.vehicletoggleDrawerRequest}
          responseManufacturer={this.state.responseManufacturer}
          vehicledrawerOpen={this.state.vehicledrawerOpen}
          vehicels={this.props.RequestVehicleDataList?.requests}
          handleRejectRequestVehicle={this.handleRejectRequestVehicle}
          handleApproveRequestVehicle={this.handleApproveRequestVehicle}
          handleCloseModal={this.handleCloseModal}
          handleOnChange={this.handleOnChange}
          rejectRequestOpen={this.state.rejectRequestOpen}
          handleRejectModalClose={this.handleRejectModalClose}
          handleRejectModalOpen={this.handleRejectModalOpen}
          handleUpdateRequestVehicle={this.handleUpdateRequestVehicle}
          handleFiltertoggleDrawer={this.handleFiltertoggleDrawerOpen}
          searchhandleChange={this.searchhandleChange}
          totalCount={this.props.RequestVehicleDataList?.totalCount}
          page={this.state?.page}
          limit={this.state?.limit}
          onPageChange={this.onPageChange}
          isLoading={this.props.isLoading}
          onChange={this.handleChange}
          datePickerOpen={this.state.datePickerOpen}
          handleDatePickerOpen={this.handleDatePickerOpen}
          handleDatePickerClose={this.handleDatePickerClose}
          from_date={this.state.formData.from_date}
          to_date={this.state.formData.to_date}
          onDatePickerSub={this.onDatePickerSub}
          fromat_date_from={this.state.formData.fromat_date_from}
          fromat_date_to={this.state.formData.fromat_date_to}
          formData={this.state.formData}
          handleManufacturerInputFieldOpen={this.handleManufacturerInputFieldOpen}
          handleModelInputFieldOpen={this.handleModelInputFieldOpen}
          handleVariantInputFieldOpen={this.handleVariantInputFieldOpen}
          variantInputFieldOpen={this.state.variantInputFieldOpen}
          modelInputFieldOpen={this.state.modelInputFieldOpen}
          manufacturerInputFieldOpen={this.state.manufacturerInputFieldOpen}
          handleReset={this.handleReset}

        />

        <FilterVehicle
         drawerOpen={this.state.filterdrawerOpen}
         filters={this.dropdownFilterData ?? []}
         filtermanufacture={filtermanufacture}
         filtermodels={filtermodels}
         filtervariants={filtervariants}
         filtermanufactureType={filtermanufactureType}
         handleFiltertoggleDrawerClose={this.handleFiltertoggleDrawerClose}
         applyFilter={this.handleFilterRequestVehicle}
        />

          <Snackbar
            open={this.state.modalMessage.open}
            autoHideDuration={3000}
            onClose={this.handleSnackbarClose}
            message={this.state.modalMessage.message}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <Alert severity="success">
              {this.state.modalMessage.message}
            </Alert>
          </Snackbar>
      </div>
    );
  }
}
